import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTheme } from '../App';
import './Navbar.css';

const Navbar = () => {
  const { theme, toggleTheme } = useTheme();
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  const isActive = (path) => location.pathname === path;

  // Don't show navbar on the chat workspace page
  if (location.pathname === '/contextlyai') return null;

  return (
    <nav className="navbar">
      <div className="navbar-inner">
        <Link to="/" className="navbar-logo">
          <div className="navbar-logo-icon">C</div>
          <span className="navbar-logo-text">Contextly AI</span>
        </Link>

        <button className="navbar-mobile-toggle" onClick={() => setMobileOpen(!mobileOpen)} aria-label="Toggle menu">
          <i className={`fa ${mobileOpen ? 'fa-times' : 'fa-bars'}`}></i>
        </button>

        <div className={`navbar-links ${mobileOpen ? 'open' : ''}`}>
          <Link to="/platform" className={`navbar-link ${isActive('/platform') ? 'active' : ''}`}>Platform</Link>
          <Link to="/solutions" className={`navbar-link ${isActive('/solutions') ? 'active' : ''}`}>Solutions</Link>
          <Link to="/pricing" className={`navbar-link ${isActive('/pricing') ? 'active' : ''}`}>Pricing</Link>
          <Link to="/docs" className={`navbar-link ${isActive('/docs') ? 'active' : ''}`}>Docs</Link>
        </div>

        <div className={`navbar-actions ${mobileOpen ? 'open' : ''}`}>
          <button className="navbar-theme-toggle" onClick={toggleTheme} aria-label="Toggle theme">
            <i className={`fa ${theme === 'dark' ? 'fa-sun' : 'fa-moon'}`}></i>
          </button>
          <Link to="/" className="navbar-cta" onClick={(e) => {
            e.preventDefault();
            // Scroll to top of main page or navigate
            window.location.href = '/';
          }}>
            Get Started <i className="fa fa-arrow-right"></i>
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
